import Richtext from '@tmh-website/components/shared/Richtext';
import Button from '@tmh-website/ui/Button';
import styled from 'styled-components';

export const ConsentOptions = styled.div`
  margin-top: 24px;

  > * {
    margin: 10px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CheckboxesContainer = styled.div`
  margin: 14px 0 10px;

  > * {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const CaptchaContainer = styled.div`
  margin-top: 20px;
`;

export const SubmitButton = styled(Button)`
  margin-top: 24px;
`;

export const HubSpotSuccessMessage = styled.div`
  margin-top: 20px;
`;

export const AdjustedRichtext = styled(Richtext)`
  font-size: 12px;
`;
